import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import AppShortcut from './AppShortcut';
import SectionMenu from './SectionMenu';
import DragHandle from './DragHandle';

function DashboardSection({
  section,
  editMode = false,
  onRename,
  onDelete,
  onAddApp,
  onEditApp,
  onMoveApp,
  onDeleteApp,
  onSaveForLater
}) {
  const headingId = `section-${section.id}`;
  const sortable = useSortable({
    id: section.id,
    data: { type: 'section' },
    disabled: !editMode
  });
  const drop = useDroppable({
    id: `drop-${section.id}`,
    data: { type: 'sectionDrop', sectionId: section.id },
    disabled: !editMode || section.apps.length > 0
  });

  const style = {
    transform: CSS.Transform.toString(sortable.transform),
    transition: sortable.transition
  };

  return (
    <section
      ref={sortable.setNodeRef}
      style={style}
      className={`tool-section${sortable.isDragging ? ' is-dragging' : ''}`}
      aria-labelledby={headingId}
    >
      <div className="section-head">
        {editMode && (
          <DragHandle
            ref={sortable.setActivatorNodeRef}
            label={`Reorder group ${section.title}`}
            {...sortable.attributes}
            {...sortable.listeners}
          />
        )}
        <h2 id={headingId} className="tool-section-title">{section.title}</h2>
        {editMode && (
          <SectionMenu
            title={section.title}
            onRename={() => onRename(section)}
            onDelete={() => onDelete(section)}
          />
        )}
      </div>
      <SortableContext items={section.apps.map((a) => a.id)} strategy={verticalListSortingStrategy}>
        <div
          ref={drop.setNodeRef}
          className={`shortcut-list${editMode ? ' is-editing' : ''}`}
        >
          {section.apps.map((app, appIndex) => (
            <AppShortcut
              key={app.id}
              app={app}
              section={section}
              index={appIndex}
              editMode={editMode}
              onEdit={() => onEditApp(app, section)}
              onMove={() => onMoveApp(app, section)}
              onDelete={() => onDeleteApp(app)}
              onSaveForLater={() => onSaveForLater(app)}
            />
          ))}
          {section.apps.length === 0 && (
            <p className="section-empty">No apps yet</p>
          )}
          {(editMode || section.apps.length === 0) && (
            <button type="button" className="add-app-btn" onClick={() => onAddApp(section)}>
              {editMode ? '+ Add App' : 'Add app'}
            </button>
          )}
        </div>
      </SortableContext>
    </section>
  );
}

export default DashboardSection;